var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAuriko(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 230 230",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-185,-183)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M298.7 247.2c-1.5.8-1.7 2.8-1.7 14.2 0 10.6.3 13.6 1.5 14.6.8.7 2.2 1 3 .6 1.2-.4 1.5-3 1.5-15 0-15-.5-16.6-4.3-14.4M247 264.5c-.6.8-1 1.8-.8 2.3.1.5 4.4 5.3 9.5 10.6 9.2 9.8 12.3 11.5 13.1 7.2.3-1.3-2.7-4.9-9.4-11.7-5.4-5.5-10.2-9.9-10.5-9.9-.4 0-1.2.7-1.9 1.5m102.8-.4c-.8.4-5.4 5.1-10.1 10.3-8.6 9.3-10.1 12.6-5.8 12.6 2.6 0 21.3-19.4 20.5-21.3-.7-2-2.6-2.7-4.6-1.6m-58.8 22c-7.4 1.2-18.9 7-24.3 12.3-8.8 8.5-14.6 20.2-16.5 32.8l-.7 5.1-12 2.2c-6.6 1.2-19.1 3.9-27.8 6-16 3.8-18.6 5.1-15.6 8 1.2 1.2 3.9.8 17.4-2.6 63.8-15.8 114.8-15.9 176-.4 9.3 2.3 17.5 4 18.2 3.8 1.9-.7 1.6-4.1-.4-5.1-2.6-1.4-31.2-8-43.3-10.1l-10.5-1.7-1.2-6.2c-4.8-23.9-18.9-39.3-40.2-43.8-7.3-1.5-11-1.6-19.1-.3m22.3 6.9c11.2 3.5 20.6 11.7 26.3 23 2.4 4.7 5.8 17.9 4.9 18.8-.2.3-6.2 0-13.2-.6-24.7-2.2-32.9-2.4-49.3-1.2-9.1.7-18.6 1.5-21.2 2-4.5.6-4.8.6-4.8-1.4 0-4.1 3.1-14 6.2-19.8 5.5-10.4 16.6-19.3 27.1-21.8 6.3-1.5 17.3-1.1 24 1",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.4 302.5c-.3.8-.3 1.9.1 2.4.3.6 6.5 2.9 13.7 5.2 11.2 3.5 13.3 3.9 14.5 2.7 2.8-2.8.3-4.5-12-8.2-13.5-4-15.5-4.3-16.3-2.1m148.6 2.4c-9.4 3-11.6 4.1-11.8 5.8-.2 1.1.3 2.3 1.1 2.6 1.8.7 24.7-6.1 26.6-7.8 1.9-1.9.6-4.5-2.1-4.4-1.3.1-7.5 1.8-13.8 3.8",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuriko);
export default __webpack_public_path__ + "static/media/auriko.9ff969c379642e4c8beba30946dbe0e5.svg";
export { ForwardRef as ReactComponent };